import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import ShowDetails from './show-details';
import AstrologyTeeup from './teeups/astrology.js';
import { smoothScrollToElement } from '../scroll';
import { nl2br }  from '../util';
import _ from 'underscore';

class Component extends BaseComponent {
    shouldComponentUpdate() {
        return false;
    }

    render({ product }) {
        if (product) {
            return (
                <product-teeup>
                    <img
                        className='product-logo'
                        alt='astrology forecast'
                        src={`https://gfx.tarot.com/images/products/${product.description.slug}/icon.svg`}
                    />
                    {this.renderMessage()}
                    <h1 className='has-text-center'>{product.description.long_name}</h1>
                    {this.renderDetails()}
                    <AstrologyTeeup />
                    {this.renderContent()}
                </product-teeup>
            );
        }

        return (<product-teeup />);
    }

    renderMessage = () => {
        if (this.props.message) {
            return (<h2 className='has-text-center'>{this.props.message}</h2>);
        } else if (this.props.product.description.message) {
            return (
                <h2 className='fancy-title has-text-boulder has-text-center'>
                    {this.props.product.description.message}
                </h2>
            );
        }

        return null;
    }

    renderDetails = () => {
        if (this.props.showContent) {
            return (<p className='has-text-center'>{this.props.product.description.subheader}</p>);
        }

        return (
            <ShowDetails
                summary={this.props.product.description.subheader}
                details={this.props.product.description.long_description}
            />
        );
    }

    renderContent = () => {
        if (this.props.showContent) {
            return (
                <div className='has-margin-50-top'>
                    <h2 className='has-margin-25-bottom'>About This {this.props.product.description.long_name}</h2>
                    <p dangerouslySetInnerHTML={{__html: nl2br(this.props.product.description.long_description)}} />
                    <row className='is-justified-center has-margin-30-top'>
                        <column>
                            <a href='' className='button' onClick={(e) =>  this.goTo(e, 'main')}>
                                START MY REPORT
                            </a>
                        </column>
                    </row>
                </div>
            );
        }

        return null;
    }

    goTo = (e, chapter) => {
        e.preventDefault();
        smoothScrollToElement(document.querySelector(chapter));
    }

}

const mapStateToProps = (state) => ({
    product: state.product,
    showContent: state.product && state.product.description && state.product.description.code
        && _.contains(['essential-birth-sample', 'astrology-compatibility-sample'], state.product.description.code),

});

export default connect(mapStateToProps)(Component);
